import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from './Label.module.scss';

const Label = (props) => {
  const {
    className,
    label,
    required,
    hasError,
    ...rest
  } = props;

  const classes = classnames(
    styles.label,
    className,
    {
      [styles.hasError]: hasError,
      [styles.required]: required
    }
  );

  return (
    <label className={classes} {...rest}>
      {label}
      {required && <span className={styles.requiredMarker}>*</span>}
    </label>
  );
};

export default Label;

Label.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  required: PropTypes.bool,
  hasError: PropTypes.bool,
  htmlFor: PropTypes.string,
};
